import { defineMessages } from 'react-intl';


const paymentMessages = defineMessages({
    mainTitle: {
        id: 'payment.paymentMessages.steptitle',
        description: 'Top-level header of the payment step',
        defaultMessage: 'Checkout'
    },
    paymentMethodSubHeading: {
        id: 'payment.paymentMessages.paymentMethodSubHeading',
        description: 'Sub header for the payment method selection section',
        defaultMessage: 'Payment Method'
    },
    paymentSelectionRadio: {
        id: 'payment.paymentMessages.paymentSelectionRadio',
        description: 'Legend message for the payment selection radio buttons',
        defaultMessage: 'Select a payment method'
    },
    creditCardRadioAriaLabel: {
        id: 'payment.paymentMessages.creditCardRadioAriaLabel',
        description: 'message for the cardit card method radio button\'s aria label',
        defaultMessage: 'Selected Credit/Debit Card'
    },
    paypalRadioAriaLabel: {
        id: 'payment.paymentMessages.paypalRadioAriaLabel',
        description: 'message for the PayPal method radio button\'s aria label',
        defaultMessage: 'Selected PayPal'
    },
    applePayRadioAriaLabel: {
        id: 'payment.paymentMessages.applePayRadioAriaLabel',
        description: 'message for the ApplePay method radio button\'s aria label',
        defaultMessage: 'Selected Apple Pay'
    },
    masterPassRadioAriaLabel: {
        id: 'payment.paymentMessages.masterPassRadioAriaLabel',
        description: 'message for the MasterPass method radio button\'s aria label',
        defaultMessage: 'Selected Masterpass'
    },
    submitButtonLabel: {
        id: 'payment.paymentMessages.submitButtonLabel',
        description: 'Label for submit button on payment form which will submit the order with payment',
        defaultMessage: 'Place my order'
    },
    submitButtonProcessingLabel: {
        id: 'payment.paymentMessages.submitButtonProcessingLabel',
        description: 'Label for submit button on payment form which will submit the order with payment which show a processing message',
        defaultMessage: 'Processing...'
    },
    stepUpOverlayMessage: {
        id: 'payment.paymentMessages.stepUpOverlayMessage',
        description: 'Message shown on the Step-Up overlay if 3DS/PSD2 payer authentiction takes a while',
        defaultMessage: 'Hang tight! We are verifying your identity. This could take several minutes.'
    },
    stepUpResultsMessage: {
        id: 'payment.paymentMessages.stepUpResultsMessage',
        description: 'Message shown on the Step-Up Results callback endpoint',
        defaultMessage: 'Your authentication is complete. Please close this window to return to your order.'
    },
    stepUpPleaseAuthenticate: {
        id: 'payment.paymentMessages.stepUpPleaseAuthenticate',
        description: 'Message Step-Up authentication form pop-out window',
        defaultMessage: 'Please Authenticate'
    },
    stepUpPopOutBlocked: {
        id: 'payment.paymentMessages.stepUpPopOutBlocked',
        description: 'Error message for Step Up being blocked by browser',
        defaultMessage: 'We need to open a pop-up window to authenticate your payment. Please change your settings to allow pop-ups for this site. If you don\'t see the pop-up after changing your settings, please refresh this page.'
    },
    stepUpPopOutBlockedHeader: {
        id: 'payment.paymentMessages.stepUpPopOutBlockedHeader',
        description: 'Error message header for Step Up being blocked by browser',
        defaultMessage: 'Payment Authentication Needed.'
    },
    editCart: {
        id: 'payment.paymentMessages.editCart',
        description: 'Label for link to leave checkout and edit the cart',
        defaultMessage: 'Edit Cart'
    },
    confirmationHeading: {
        id: 'payment.paymentMessages.confirmationHeading',
        description: 'Top-level header of the payment confirmation',
        defaultMessage: 'Thanks for your order'
    },
    
    confirmationTitle: {
        id: 'payment.paymentMessages.confirmationTitle',
        description: 'Top-level header of the payment confirmation',
        defaultMessage: 'Thanks for your order'
    },
    statusHeadline: {
        id: 'payment.paymentMessages.statusHeadline',
        description: 'Headline for status of the order (StatusHeadline component, payment confirmation page)',
        defaultMessage: 'Your order is currently processing.'
    },
    statusMessage: {
        id: 'payment.paymentMessages.statusMessage',
        description: 'Message with status of the order and instructions (StatusHeadline component, payment confirmation page)',
        defaultMessage: 'You should receive a status email shortly with your order details.'
    },
    orderNumberSubtitle: {
        id: 'payment.paymentMessages.orderNumberSubtitle',
        description: 'Subtitle of the confirmation with the Order Number',
        defaultMessage: 'Order Number: {number}'
    },
    billingToLabel: {
        id: 'payment.paymentMessages.billingToLabel',
        description: 'Label for the billing address',
        defaultMessage: 'Billing To'
    },
    sharePromoHeading: {
        id: 'payment.paymentMessages.sharePromoHeading',
        description: 'Heading for promotion share',
        defaultMessage: 'Share offer with friends'
    },
    orderDetailsTitle: {
        id: 'payment.paymentMessages.orderDetailsTitle',
        description: 'Subheading for the order details section',
        defaultMessage: 'Order details'
    },
    digitalItemLabel: {
        id: 'payment.paymentMessages.digitalItemLabel',
        description: 'Section heading used to describe the digital cards ordered on the order confirmation page',
        defaultMessage: '{itemCount, plural, one {eGift Card} other {eGift Cards}}'
    },
    plasticItemLabel: {
        id: 'payment.paymentMessages.plasticItemLabel',
        description: 'Section heading used to describe plastic cards ordered on the order confirmation page',
        defaultMessage: '{itemCount, plural, one {Gift Card} other {Gift Cards}}'
    },
    promoItemLabel: {
        id: 'payment.paymentMessages.promoItemLabel',
        description: 'Section heading used to describe promotional cards recieved on the order confirmation page',
        defaultMessage: '{itemCount, plural, one {Promotional Card} other {Promotional Cards}}'
    },
    buyAnotherCardButton: {
        id: 'payment.paymentMessages.buyAnotherCardButton',
        description: 'Button to begin placing another order',
        defaultMessage: 'Buy Another Card'
    },
    cardholderAgreementImplicit: {
        id: 'payment.paymentMessages.cardholderAgreementImplicit.md',
        description: 'the text of the implicit cardholder agreement',
        defaultMessage: 'By continuing to purchase, you are agreeing to the Cardholder Agreement.'
    },
    cardholderAgreementExplicit: {
        id: 'payment.paymentMessages.cardholderAgreementExplicit.md',
        description: 'the text of the explicit cardholder agreement',
        defaultMessage: 'By checking this box, you are agreeing to the Cardholder Agreement.'
    },
    selfBuyDeliverySMSLabel: {
        id: 'payment.paymentMessages.selfBuyDeliverySMSLabel',
        description: 'label for sms delivery opt-in toggle',
        defaultMessage: 'Also Send your digital card(s) via SMS'
    },
    selfBuyDeliverySMSDescripition: {
        id: 'payment.paymentMessages.selfBuyDeliverySMSDescripition',
        description: 'description for sms delivery opt-in toggle',
        defaultMessage: 'By providing your mobile number, you consent to initiate text message(s) from {brandName} to your number with the eGift Card link(s)'
    }
});

export default paymentMessages;
